import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import Styles from '../../styles/minisite/minisite.module.css';
import { Icon } from 'semantic-ui-react';
import i18n from 'i18next';

function MinisiteStatus({ site, onScheduled, event, onConversion }) {
    const { t } = useTranslation();
    const status = React.useMemo(() => {
        if (site.is_published) {
            return 'online';
        }
        if (site.delivery && site.delivery.on_date) {
            return 'scheduled';
        }
        if (site.delivery && site.delivery.on_publish && site.delivery.on_publish.length > 0) {
            return 'event';
        }
        return 'offline';
    }, [site]);

    const displayDate = React.useMemo(() => {
        if (site && site.delivery && site.delivery.on_date) {
            moment.locale(i18n.language);
            return moment(site.delivery.on_date).format('dddd Do MMMM YYYY, HH:mm');
        }
        return null;
    }, [site]);

    // Trick for events created before 2021-10-05 date of lauch of new mini-site
    if (!site.was_published && !site.is_published && status === 'offline') {
        if (new Date(event.created) < new Date('2021-10-16')) {
            return (
                <div className={`${Styles['status-minisite-container']} ${Styles['status-minisite-event']}`}>
                    <div className={Styles['status-minisite-content']}>{t(`ticket.event.minisite.status.conversion-text`)}</div>
                    <div className={Styles['status-minisite-action']}>
                        <span onClick={onConversion}>{t(`ticket.event.minisite.status.conversion-publish`)}</span>
                    </div>
                </div>
            );
        }
    }

    return (
        <div className={`${Styles['status-minisite-container']} ${Styles['status-minisite-' + status]}`}>
            {status !== 'event' && (
                <div className={Styles['status-minisite-title']}>
                    <Icon name="circle" /> <span>{t(`ticket.event.minisite.status.${status}`)}</span>
                </div>
            )}
            <div className={Styles['status-minisite-content']}>{t(`ticket.event.minisite.status.${status}-text`, { date: displayDate })}</div>
            {(status === 'event' || status === 'scheduled') && (
                <div className={Styles['status-minisite-action']}>
                    {status === 'scheduled' && <span onClick={onScheduled}>{t(`ticket.common.action.edit`)}</span>}
                    {status === 'event' && (
                        <span onClick={() => (window.location = `${window.weezConfig.temporary.menhirUrl}/bo/tableau_bord_accueil.php?id_evenement=${event.id}`)}>
                            {t(`ticket.event.minisite.status.publish`)}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
}

MinisiteStatus.propTypes = {
    site: PropTypes.object.isRequired,
    onScheduled: PropTypes.func.isRequired,
    eventId: PropTypes.string.isRequired
};

export default MinisiteStatus;
